import { apiGet, apiPost } from './apiClient';
import { ResponseDTO, PasswordResetRequestDTO, PasswordResetConfirmDTO } from '@/types/api';

const BASE = '/api/v1/users/password-reset';

export async function requestPasswordReset(dto: PasswordResetRequestDTO): Promise<string> {
  const res = await apiPost<ResponseDTO<null>>(`${BASE}/request`, dto);
  return res.message || 'Password reset email sent';
}

export async function validateResetToken(token: string): Promise<string> {
  const res = await apiGet<ResponseDTO<null>>(`${BASE}/validate`, { params: { token } });
  return res.message || 'Token is valid';
}

export async function confirmPasswordReset(dto: PasswordResetConfirmDTO): Promise<string> {
  const res = await apiPost<ResponseDTO<null>>(`${BASE}/confirm`, dto);
  return res.message || 'Password reset successful';
}
